var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"img-background"},[_c('v-card-title',{staticClass:"text-center justify-center py-6 text-h5",staticStyle:{"margin-top":"10%","font-weight":"bold"}},[_vm._v(" Qual seu tipo de atendimento? ")]),_c('v-container',[[_c('PreferentialMain')],_c('br'),[_c('PreferentialImages')]],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }